import * as React from 'react';

import { GRADIENT_ARROW_WIDTH } from '../../constants/arrows';
import { IHeadCategory } from '../../types/promosPage';
import { HeadCategoryLink } from '../HeadCategoryLink';
import { RoundArrowLeft } from '../RoundArrowLeft';
import { RoundArrowRight } from '../RoundArrowRight';
import { Section } from '../Section';
import { VerticalSlider } from '../VerticalSlider';

interface IHeadCategoriesProps {
  categories: IHeadCategory[];
  onClick(category: IHeadCategory, position: number): void;
}

export const HeadCategories: React.FC<IHeadCategoriesProps> = ({ categories, onClick }) => {
  const handleClick = React.useCallback(
    (category: IHeadCategory, position: number) => () => {
      onClick(category, position);
    },
    [onClick],
  );

  return (
    <Section data-testid="HeadCategoriesSection">
      <VerticalSlider rightArrow={RoundArrowRight} leftArrow={RoundArrowLeft} scrollOffset={GRADIENT_ARROW_WIDTH}>
        {categories.map((category, idx) => (
          <HeadCategoryLink
            key={idx}
            href={category.url}
            iconUrl={category.iconUrl}
            onClick={handleClick(category, idx + 2)}
            allCategory={idx === 0}
          >
            {category.name}
          </HeadCategoryLink>
        ))}
      </VerticalSlider>
    </Section>
  );
};
